import React from "react";
import LivestreamPage from "../common/LivestreamPage";
import Brian from "./assets/Brian.JPG";
import TradeAlertsSidebar from "./TradeAlertsSidebar";

const OptionsAcademyLivestream = ({ isSupport = false }) => {
  // Different event IDs for livestream vs support
  const eventID = isSupport ? "3495152" : "3495126";
  const videoKey = isSupport
    ? "options-academy-qa"
    : "options-academy-livestream";

  // Different time schedules
  const time = isSupport ? "11:30am" : "2:00pm";

  const schedules = [
    { day: "Mon", time: `${time} EST` },
    { day: "Tue", time: `${time} EST` },
    { day: "Wed", time: `${time} EST` },
    { day: "Thu", time: `${time} EST` },
    { day: "Fri", time: `${time} EST` },
  ];

  const contentDescription = (
    <>
      This is a live trading experience where viewers can learn from a
      professional trader, Bronco, as he shares his desktop platform and
      provides analysis, trading tactics, and risk management strategies. The
      show offers insights into price action on charts and empirical reasons for
      projected profits.
    </>
  );

  return (
    <div className="support-livestream-container">
      <LivestreamPage
        eventID={eventID}
        videoKey={videoKey}
        authorName="Bronco Anderson"
        authorTitle="TradeAlgo Professional Analyst"
        authorAvatar={Brian}
        contentTitle="Options Academy Livestream"
        contentDescription={contentDescription}
        showSchedule={true}
        schedules={schedules}
        scheduleTitle="Live Schedule"
        sidebarComponent={
          <TradeAlertsSidebar telegramUrl="https://t.me/+RL6bcEckMI82ZTYx" />
        }
        customPageSize={19}
        className="options-academy-livestream"
      />
    </div>
  );
};

export default OptionsAcademyLivestream;
